import { createRowNavigatePath } from "@/components/data-table/_helpers/create-row-navigate-path";
import { GroupTable } from "@/components/data-table/predefined/group-table";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";

export function GroupView() {
  const { t } = useTranslation(["ram", "common"]);

  return (
    <CenteredLayout
      variant={CenteredLayoutVariant.Table}
      title={t("ram:Groups")}
      subTitle={t("common:SearchFilterAndManageEntriesDescription")}
    >
      <GroupTable onRowNavigate={createRowNavigatePath("/ram/group")} />
    </CenteredLayout>
  );
}
